import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useRef } from "react";
import "./index.css";
import AutocompleteArrow from "../AutocompleteDropdownArrow";

const EditableAutocompleteNonCategory = ({
  chosen,
  classStyle = "newreact__select__azilis",
  setValue,
  disabled = false,
  propertyName = "value",
  styleNo = 1,
  scrollLeft = 0,
  menu,
  edit,
  options,
  check,
}) => {
  const divRef = useRef();

  const renderGroup = (params) => (
    <li key={params.key}>
      <div style={{ fontWeight: "600" }}>{params.group}</div>
      <ul style={{ width: "100%" }}>{params.children}</ul>
    </li>
  );

  return (
    <>
      {!edit ? (
        check === "noProperty" ? (
          <h4>{chosen}</h4>
        ) : (
          <h4>{chosen ? chosen[propertyName] : ""}</h4>
        )
      ) : (
        <div className="w-100" ref={divRef}>
          <Autocomplete
            className={classStyle + " azilis__dropdown__style" + styleNo}
            classNamePrefix="select__prefix__azilis"
            onChange={(event, opt) => {
              setValue(opt);
            }}
            value={
              check === "noProperty"
                ? chosen || null
                : chosen?.[propertyName] || null
            }
            disabled={disabled}
            isSearchable
            filterOptions={(options, { inputValue }) => {
              return options.filter((option) => {
                if (option?.title) {
                  return option?.title
                    ?.toLowerCase()
                    .includes(inputValue.toLowerCase());
                } else if (option?.value) {
                  return option?.value
                    ?.toLowerCase()
                    .includes(inputValue.toLowerCase());
                } else {
                  return [];
                }
              });
            }}
            options={options}
            getOptionLabel={(option) => {
              if (typeof option === "string") {
                return option;
              }
              if (option && typeof option === "object") {
                return option.value || option.title || option.name || "";
              }
              return "";
            }}
            popupIcon={<AutocompleteArrow />}
            isOptionEqualToValue={(option, value) => {
              if (typeof value === "string") {
                return (
                  option.value === value ||
                  option.title === value ||
                  option.name === value
                );
              }
              return option === value;
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  sx: {
                    fontSize: "12px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: "12px",
                  },
                }}
              />
            )}
            renderGroup={renderGroup}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                {option.value || option.title || option.name || ""}
              </li>
            )}
            componentsProps={{
              paper: {
                sx: {
                  width: 300,
                },
              },
              clearIndicator: {
                sx: {
                  color: "white",
                  right: "-5px",
                  top: "10%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  "& .MuiSvgIcon-root": {
                    fontSize: "12px",
                  },
                },
              },
            }}
            styles={{
              menu: (baseStyles, state) => ({
                ...baseStyles,
                left: divRef.current
                  ? divRef.current.offsetLeft - scrollLeft + "px"
                  : "unset",
              }),
            }}
            classes={{
              paper: "dropdown-bg-custom",
            }}
            sx={{
              "& .MuiAutocomplete-inputRoot": {
                paddingRight: "0",
              },
              "&.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root": {
                paddingRight: "0",
              },
              "&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root":
                {
                  paddingRight: "5px",
                },
              "& .MuiAutocomplete-popupIndicator": {
                top: "5px",
              },
            }}
          />
        </div>
      )}
    </>
  );
};

export default EditableAutocompleteNonCategory;
